import {jsonMember, jsonObject} from "typedjson";

/** Опций пагинации для грида. */
@jsonObject
export class DxGridPaginationOptions {
  /**
   * Активация автоподгонки размера страницы.
   * Грид автоматически подгоняет размер страницы, так чтоб полностью заполнить по высоте область,
   * выделенную под таблицу.
   */
  @jsonMember({name: "useAutoPageSize", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _useAutoPageSize: boolean = false;

  /** Размер страницы. */
  @jsonMember({name: "pageSize", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _pageSize: number;

  /** Флаг позволяет отключить встроенную панель с пагинацией и использовать внешнюю. */
  @jsonMember({name: "suppressDefaultPaginationPanel", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _suppressDefaultPaginationPanel: boolean = false;

  get useAutoPageSize(): boolean {
    return this._useAutoPageSize;
  }

  set useAutoPageSize(value: boolean) {
    this._useAutoPageSize = value;
  }

  get pageSize(): number {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
  }

  get suppressDefaultPaginationPanel(): boolean {
    return this._suppressDefaultPaginationPanel;
  }

  set suppressDefaultPaginationPanel(value: boolean) {
    this._suppressDefaultPaginationPanel = value;
  }
}
